import moment, { Moment } from 'moment';
import pluralize from 'pluralize';

import { toSentence } from '@utils/strings';

class Countdown {
  static timeRemaining (incomingEndTime: Date | Moment, incomingStartTime: Date | Moment = moment()) {
    if (!incomingEndTime) return {
      days: 0,
      hours: 0,
      minutes: 0,
      months: 0,
      seconds: 0,
      weeks: 0,
      year: 0
    };

    const endTime = moment(incomingEndTime);
    const startTime = moment(incomingStartTime);
    const duration = moment.duration(endTime.diff(startTime));
    const days = duration.get('days');

    return {
      days: days >= 7 ? days % 7 : days,
      hours: duration.get('hours'),
      minutes: duration.get('minutes'),
      months: duration.get('months'),
      seconds: duration.get('seconds'),
      weeks: duration.get('weeks'),
      years: duration.get('years')
    };
  }

  static prettify (endTime, startTime: Date | Moment = new Date()) {
    const t = Countdown.timeRemaining(endTime, startTime);
    const text = `months: ${t.months} ` +
                 `weeks: ${t.weeks} ` +
                 `days: ${t.days} ` +
                 `hours: ${t.hours} ` +
                 `minutes: ${t.minutes} ` +
                 `seconds: ${t.seconds}`;

    return text;
  }

  // Display as pretty duration, e.g. "1 month, 2 days, 4 hours and 28 seconds."
  static asDuration (endTime, startTime: Date | Moment = new Date()) {
    const t = Countdown.timeRemaining(endTime, startTime);
    const textArr = [];

    ['year', 'month', 'week', 'day', 'hour', 'minute', 'second'].forEach(unit => {
      const key = `${unit}s`; // e.g. months and not month as a key
      const value = t[key];

      // Don't include the unit if it's 0.
      if (value === 0) return;

      const displayUnit = pluralize(unit, value);

      textArr.push(`${value} ${displayUnit}`);
    });

    return toSentence(textArr);
  }

  static startClock (endTime, startTime = new Date(), showPretty = false) {
    let text = Countdown.prettify(endTime, startTime);
    let object = Countdown.timeRemaining(endTime, startTime);

    const timeinterval = setInterval(() => {
      object = Countdown.timeRemaining(endTime, startTime);
      text = Countdown.prettify(endTime, startTime);

      if (object.total <= 0) clearInterval(timeinterval);
    },1000);

    if (showPretty) return text;

    return object;
  }
}

export default Countdown;
